module.exports = __webpack_public_path__ + "static/media/avatar21.3bc365df.png";